import differenceBy from "lodash/differenceBy";
import get from "lodash/get";
import mapValues from "lodash/mapValues";
import { multiDocumentValidation } from "./multiDocumentValidaton";
import { PERSONAL_BANK_STATEMENTS, PERSONAL_BACKGROUND } from "./../constants";

export const concatCompanyDocs = (
  existDocs,
  incomeDocs,
  type = "",
  organizationInfo = {},
  orgKYCDetails = {}
) => {
  const companyDocsDiff = differenceBy(incomeDocs, existDocs, "documentType");
  let docs = [...(existDocs || []), ...companyDocsDiff];
  if (type) {
    docs = multiDocumentValidation(docs, type, organizationInfo, orgKYCDetails);
  }
  return docs;
};

// ro-assist-brd2-1
export const concatStakeholdersDocs = (
  neededDocs,
  uploadedDocs,
  organizationInfo = [],
  orgKYCDetails = []
) => {
  const stakeholdersDocuments = Object.entries(neededDocs || {}).reduce(
    (
      acc,
      [signatoryId, { documents, isDocUpdate, personalBankStatements, personalBackground }]
    ) => {
      acc[signatoryId] = {
        documents: documents.map(
          document =>
            get(uploadedDocs, `['${signatoryId}'].documents`, []).find(
              uploadedDoc =>
                uploadedDoc.documentKey === document.documentKey &&
                uploadedDoc.documentTitle === document.documentTitle
            ) || document
        ),
        isDocUpdate,
        personalBankStatements: {
          documents: (get(uploadedDocs, `['${signatoryId}'].personalBankStatements.documents`, [])
            .length > personalBankStatements.documents.length
            ? get(uploadedDocs, `['${signatoryId}'].personalBankStatements.documents`, [])
            : personalBankStatements.documents
          ).map(document => {
            return (
              get(uploadedDocs, `['${signatoryId}'].personalBankStatements.documents`, []).find(
                uploadedDoc =>
                  uploadedDoc.documentKey === document.documentKey &&
                  uploadedDoc.documentTitle === document.documentTitle
              ) || document
            );
          }),
          isDocUpdate: personalBankStatements.isDocUpdate,
          limit: personalBankStatements.limit
        },
        personalBackground: {
          documents: (get(uploadedDocs, `['${signatoryId}'].personalBackground.documents`, [])
            .length > personalBackground.documents.length
            ? get(uploadedDocs, `['${signatoryId}'].personalBackground.documents`, [])
            : personalBackground.documents
          ).map(document => {
            return (
              get(uploadedDocs, `['${signatoryId}'].personalBackground.documents`, []).find(
                uploadedDoc =>
                  uploadedDoc.documentKey === document.documentKey &&
                  uploadedDoc.documentTitle === document.documentTitle
              ) || document
            );
          }),
          isDocUpdate: personalBackground.isDocUpdate,
          limit: personalBackground.limit
        }
      };
      return acc;
    },
    {}
  );
  const newStakeDocs = mapValues(stakeholdersDocuments, stakeHolder => {
    return {
      ...stakeHolder,
      personalBankStatements: {
        ...stakeHolder.personalBankStatements,
        documents: multiDocumentValidation(
          stakeHolder.personalBankStatements.documents,
          PERSONAL_BANK_STATEMENTS,
          organizationInfo,
          orgKYCDetails
        )
      },
      personalBackground: {
        ...stakeHolder.personalBackground,
        documents: multiDocumentValidation(
          stakeHolder.personalBackground.documents,
          PERSONAL_BACKGROUND,
          organizationInfo,
          orgKYCDetails
        )
      }
    };
  });
  return newStakeDocs;
};

export const createDocumentMapper = (documentKey, additionalProps) => doc => {
  if (doc.documentKey === documentKey) {
    return { ...doc, ...additionalProps };
  }

  return doc;
};

const removePrefix = name => name.replace(/^\d+_/, ""); // Removes "0_" or any number followed by "_"

export const appendDocumentKey = (docs, stakeholderName = "") => {
  const cleanedName = stakeholderName ? `${removePrefix(stakeholderName)}-` : "";
  return (docs || []).map((doc, index) => {
    const docIndex = docs
      .slice(0, index)
      .filter(document => document.documentType === doc.documentType).length;
    return { ...doc, documentKey: `${cleanedName}${doc.documentType}-${docIndex}` };
  });
};

// ro-assist-brd2-1
export const appendMultiDocumentKey = (docs, stakeholderName = "") => {
  const cleanedName = stakeholderName ? `${removePrefix(stakeholderName)}-` : "";
  const indexedDocs = (docs.documents || []).map((doc, index) => {
    const docIndex = docs.documents
      .slice(0, index)
      .filter(document => document.documentType === doc.documentType).length;
    return { ...doc, documentKey: `${cleanedName}${doc.documentType}-${docIndex}` };
  });
  return { ...docs, documents: indexedDocs };
};

export const range = (end, start = 0) => Array.from({ length: end - start }, (_, i) => start + i);

export const extractDocumentTypes = documents => {
  let documentTypes = [];

  const traverse = doc => {
    if (Array.isArray(doc)) {
      doc.forEach(item => traverse(item));
    } else if (typeof doc === "object" && doc !== null) {
      if (doc.documentType) {
        documentTypes.push(doc.documentType);
      }
      for (let key in doc) {
        traverse(doc[key]);
      }
    }
  };

  traverse(documents);
  return [...new Set(documentTypes)]; // Return unique document types
};

export const mapDocumentType = (fileInfo, documentTypes) => {
  if (documentTypes.indexOf(fileInfo.documentType) === -1) {
    const findDocIndex = documentTypes.indexOf(fileInfo.documentType.replace(/_/g, " "));
    if (findDocIndex > -1) {
      fileInfo.documentType = documentTypes[findDocIndex];
      fileInfo.documentKey = fileInfo.documentKey.replace(/_/g, " ");
    }
  }
  return fileInfo;
};
